import * as React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../../../store';
import { TabScreens } from '../../../routes';

export const MenuTabSvg: React.FC = () => {
    const currentTabScreen = useSelector(
        (state: RootState) => state.tabSlice.screen,
    );

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 512 512" fill={
            currentTabScreen === TabScreens.Menu
                ? 'var(--main-turquoise)'
                : 'var(--text-color)'
        }>
            {/* fill inside color */}

            <path
                fill={
                    currentTabScreen === TabScreens.Menu
                        ? 'var(--main-turquoise)'
                        : 'var(--text-color)'
                }
                fillOpacity={0.15}
                d="M256 480h139.31a32 32 0 0 0 31.91-29.61L463 112"
            />
            <path
                fill={
                    currentTabScreen === TabScreens.Menu
                        ? 'var(--main-turquoise)'
                        : 'var(--text-color)'
                }
                fillOpacity={0.15}
                d="M322 416c0 35.35-20.65 64-56 64H134c-35.35 0-56-28.65-56-64m258-80c17.67 0 32 17.91 32 40h0c0 22.09-14.33 40-32 40H64c-17.67 0-32-17.91-32-40h0c0-22.09 14.33-40 32-40"
            />
            <path
                fill={
                    currentTabScreen === TabScreens.Menu
                        ? 'var(--main-turquoise)'
                        : 'var(--text-color)'
                }
                fillOpacity={0.15}
                d="M344 336H179.31a8 8 0 0 0-5.65 2.34l-26.83 26.83a4 4 0 0 1-5.66 0l-26.83-26.83a8 8 0 0 0-5.65-2.34H56a24 24 0 0 1-24-24h0a24 24 0 0 1 24-24h288a24 24 0 0 1 24 24h0a24 24 0 0 1-24 24ZM64 276v-.22c0-55 45-83.78 100-83.78h72c55 0 100 29 100 84v-.22M241 112l7.44 63.97"
            />
            <path
                fill={
                    currentTabScreen === TabScreens.Menu
                        ? 'var(--main-turquoise)'
                        : 'var(--text-color)'
                }
                fillOpacity={0.15}
                d="m368 112l16-64l47-16"
            />
            <path
                fill={
                    currentTabScreen === TabScreens.Menu
                        ? 'var(--main-turquoise)'
                        : 'var(--text-color)'
                }
                fillOpacity={0.15}
                d="M224 112h256"
            />


            {/* icon */}
            <path fill="none" stroke={
                currentTabScreen === TabScreens.Menu
                    ? 'var(--main-turquoise)'
                    : 'var(--text-color)'
            } stroke-linecap="round" stroke-miterlimit="10" stroke-width="32" d="M322 416c0 35.35-20.65 64-56 64H134c-35.35 0-56-28.65-56-64m258-80c17.67 0 32 17.91 32 40h0c0 22.09-14.33 40-32 40H64c-17.67 0-32-17.91-32-40h0c0-22.09 14.33-40 32-40" />
            <path fill="none" stroke={
                currentTabScreen === TabScreens.Menu
                    ? 'var(--main-turquoise)'
                    : 'var(--text-color)'
            } stroke-linecap="round" stroke-miterlimit="10" stroke-width="32" d="M344 336H179.31a8 8 0 0 0-5.65 2.34l-26.83 26.83a4 4 0 0 1-5.66 0l-26.83-26.83a8 8 0 0 0-5.65-2.34H56a24 24 0 0 1-24-24h0a24 24 0 0 1 24-24h288a24 24 0 0 1 24 24h0a24 24 0 0 1-24 24ZM64 276v-.22c0-55 45-83.78 100-83.78h72c55 0 100 29 100 84v-.22M241 112l7.44 63.97" />
            <path fill="none" stroke={
                currentTabScreen === TabScreens.Menu
                    ? 'var(--main-turquoise)'
                    : 'var(--text-color)'
            } stroke-linecap="round" stroke-miterlimit="10" stroke-width="32" d="M256 480h139.31a32 32 0 0 0 31.91-29.61L463 112" />
            <path fill="none" stroke={
                currentTabScreen === TabScreens.Menu
                    ? 'var(--main-turquoise)'
                    : 'var(--text-color)'
            } stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="m368 112l16-64l47-16" />
            <path fill="none" stroke={
                currentTabScreen === TabScreens.Menu
                    ? 'var(--main-turquoise)'
                    : 'var(--text-color)'
            } stroke-linecap="round" stroke-miterlimit="10" stroke-width="32" d="M224 112h256" />
        </svg>
    );
};